import { Button, Modal } from "react-bootstrap";
import ApproveWithdraw from "./ApproveWithdraw";

const ApproveWithdrawModal = ({
  title,
  handleClose,
  show,
  data,
  refetchRequestList,
}) => {
  return (
    <Modal className="fade lao" show={show} onHide={handleClose} size="lg">
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <Button variant="" className="btn-close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <ApproveWithdraw
          handleClose={handleClose}
          data={data}
          refetchRequestList={refetchRequestList}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ApproveWithdrawModal;
